"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaylistTargetsResponseToJSON = exports.PlaylistTargetsResponseFromJSONTyped = exports.PlaylistTargetsResponseFromJSON = exports.instanceOfPlaylistTargetsResponse = void 0;
var runtime_1 = require("../runtime");
var TargetBase_1 = require("./TargetBase");
/**
 * Check if a given object implements the PlaylistTargetsResponse interface.
 */
function instanceOfPlaylistTargetsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfPlaylistTargetsResponse = instanceOfPlaylistTargetsResponse;
function PlaylistTargetsResponseFromJSON(json) {
    return PlaylistTargetsResponseFromJSONTyped(json, false);
}
exports.PlaylistTargetsResponseFromJSON = PlaylistTargetsResponseFromJSON;
function PlaylistTargetsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'playlists': !(0, runtime_1.exists)(json, 'playlists') ? undefined : (json['playlists'].map(TargetBase_1.TargetBaseFromJSON)),
    };
}
exports.PlaylistTargetsResponseFromJSONTyped = PlaylistTargetsResponseFromJSONTyped;
function PlaylistTargetsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'playlists': value.playlists === undefined ? undefined : (value.playlists.map(TargetBase_1.TargetBaseToJSON)),
    };
}
exports.PlaylistTargetsResponseToJSON = PlaylistTargetsResponseToJSON;
